import axios from "axios";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
import vailcode from "@utils/errcode";
import cookie from "js-cookie";
export default {
  name: "popTask",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"])
  },
  data() {
    return {
      modifyData: {},
      isUploading: false,
      isSubmit: false
    };
  },
  watch: {
    "$parent.popGameAdvShow": {
      async handler(newVal, oldVal) {
        if (newVal) {
          this.modifyData = Object.assign({}, this.$parent.modifyData);
          if (!this.modifyData.id) {
            this.modifyData.check_countdown = 15;
            this.modifyData.check_countdown_prompt = 'Mission not completed';
          }
        } else {
          this.isSubmit = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async onConfirm() {
      if (this.isSubmit) return false;
      this.isSubmit = true;
      let rs = await this.$http.post("/game/adv/modify", this.modifyData);
      this.isSubmit = false;
      vailcode(rs, () => {
        this.$parent.getData();
        this.$parent.popGameAdvShow = false;
      });
    }
  }
};